import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-supply-chain-and-transportation',
  imports: [PillarPagesTemp],
  templateUrl: './supply-chain-and-transportation.html',
  styleUrl: './supply-chain-and-transportation.scss',
})
export class SupplyChainAndTransportation {

}
